var _g;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRemove(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 1430105477"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 2660",
    cx: 14,
    cy: 14,
    r: 14,
    fill: "white",
    fillOpacity: 0.82
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M13.9973 5.60034C9.36796 5.60034 5.59729 9.37101 5.59729 14.0003C5.59729 18.6297 9.36796 22.4003 13.9973 22.4003C18.6266 22.4003 22.3973 18.6297 22.3973 14.0003C22.3973 9.37101 18.6266 5.60034 13.9973 5.60034ZM18.16 16.9683L16.9653 18.163L13.9973 15.195L11.0293 18.163L9.83462 16.9683L12.8026 14.0003L9.83462 11.0323L11.0293 9.83768L13.9973 12.8057L16.9653 9.83768L18.16 11.0323L15.192 14.0003L18.16 16.9683Z",
    fill: "#DC1919"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemove);
export default __webpack_public_path__ + "static/media/remove.f71f927acaf2f259a19b907234f80ed0.svg";
export { ForwardRef as ReactComponent };